"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiCheckbox = _interopRequireDefault(require("@tencent/spaui-checkbox"));

var _info = _interopRequireDefault(require("./info"));

var _classnames = _interopRequireDefault(require("classnames"));

var _checkboxgroup_props = require("./checkboxgroup_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var CheckboxGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CheckboxGroup, _PureComponent);

  function CheckboxGroup() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CheckboxGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CheckboxGroup)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event, value) {
      var _this$props = _this.props,
          propsValue = _this$props.value,
          onChange = _this$props.onChange;
      var result = [];
      var index = -1;
      var currentValue = '';

      if ((0, _spauiUtils.isFunction)(onChange)) {
        currentValue = typeof value === 'number' ? value : value || event.target.value; // 复制一下value

        result = (0, _spauiUtils.cloneArray)(propsValue);

        if (event.target.checked) {
          result.push(currentValue);
        } else {
          index = (0, _spauiUtils.indexOf)(propsValue, currentValue);

          if (index > -1) {
            result.splice(index, 1);
          }
        }

        onChange(event, result);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckAllChange", function (event) {
      var _this$props2 = _this.props,
          _this$props2$data = _this$props2.data,
          data = _this$props2$data === void 0 ? [] : _this$props2$data,
          _this$props2$value = _this$props2.value,
          value = _this$props2$value === void 0 ? [] : _this$props2$value,
          onChange = _this$props2.onChange;
      var result = [];

      if ((0, _spauiUtils.isFunction)(onChange)) {
        // 如果选中的话
        if (event.target.checked) {
          data.map(function (item) {
            if (item) {
              // 非禁用 或 禁用但是原来是选中的
              if (!item.disabled || (0, _spauiUtils.indexOf)(value, item.value) > -1) {
                result.push(item.value);
              }
            }

            return item;
          });
        } else {
          data.map(function (item) {
            if (item) {
              // 非禁用 或 禁用但是原来是选中的
              if (item.disabled && (0, _spauiUtils.indexOf)(value, item.value) > -1) {
                result.push(item.value);
              }
            }

            return item;
          });
        }

        onChange(event, result);
      }
    });

    return _this;
  }

  _createClass(CheckboxGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "isAllChecked",
    value: function isAllChecked() {
      var _this$props3 = this.props,
          _this$props3$data = _this$props3.data,
          data = _this$props3$data === void 0 ? [] : _this$props3$data,
          _this$props3$value = _this$props3.value,
          value = _this$props3$value === void 0 ? [] : _this$props3$value;
      var result = false;

      if (value.length > 0) {
        result = true;
        data.map(function (item) {
          if (item && !item.disabled && (0, _spauiUtils.indexOf)(value, item.value) < 0) {
            result = false;
          }

          return item;
        });
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          name = _this$props4.name,
          data = _this$props4.data,
          _this$props4$value = _this$props4.value,
          value = _this$props4$value === void 0 ? [] : _this$props4$value,
          disabled = _this$props4.disabled,
          _this$props4$Checkbox = _this$props4.CheckboxProps,
          CheckboxProps = _this$props4$Checkbox === void 0 ? {} : _this$props4$Checkbox,
          vertical = _this$props4.vertical,
          _this$props4$checkAll = _this$props4.checkAll,
          checkAll = _this$props4$checkAll === void 0 ? false : _this$props4$checkAll,
          checkAllLabel = _this$props4.checkAllLabel,
          _this$props4$tipField = _this$props4.tipFieldName,
          tipFieldName = _this$props4$tipField === void 0 ? '' : _this$props4$tipField,
          useNewUI = _this$props4.useNewUI;
      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-checkbox-group', {
          'with-vertical': vertical,
          'use-newui': useNewUI
        })
      }, CheckboxGroup), checkAll ? _react["default"].createElement(_spauiCheckbox["default"], _extends({
        name: name,
        disabled: disabled
      }, CheckboxProps, {
        checked: this.isAllChecked(),
        onChange: this.handleCheckAllChange
      }), checkAllLabel) : null, data.map(function (item) {
        var result = [];
        var checkboxProps = {};
        checkboxProps = (0, _spauiUtils.objectAssign)({}, item); // 去掉不需要的属性

        delete checkboxProps.children;
        delete checkboxProps.onChange;
        delete checkboxProps.checked;

        if (name) {
          checkboxProps.name = name;
        }

        if (disabled) {
          checkboxProps.disabled = true;
        }

        var checkboxAllProps = _objectSpread({}, CheckboxProps, {}, checkboxProps); // 如果有字段提示字段名，就替换一下


        if (tipFieldName) {
          checkboxAllProps.tip = checkboxAllProps[tipFieldName];
        }

        result.push(_react["default"].createElement(_spauiCheckbox["default"], _extends({}, checkboxAllProps, {
          key: "".concat(item.value, "_checkbox"),
          checked: value.indexOf(item.value) > -1,
          onChange: _this2.handleChange
        }), item.children));

        if (typeof item.addon !== 'undefined') {
          result.push((0, _react.cloneElement)(item.addon, {
            key: "".concat(item.value, "_addon")
          }));
        }

        return result;
      }));
    }
  }]);

  return CheckboxGroup;
}(_react.PureComponent); // 组件标记


_defineProperty(CheckboxGroup, "propTypes", _checkboxgroup_props.propTypes);

_defineProperty(CheckboxGroup, "defaultProps", _checkboxgroup_props.defaultProps);

(0, _spauiUtils.setComponentMark)(CheckboxGroup, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = CheckboxGroup;
exports["default"] = _default;